/* global $ */

import 'slick-carousel';

const $sliders = $('.js-home-slider');

const homeSlider = {
  initialize() {
    if ($sliders.length) {
      this.create();
    }
  },

  create() {
    $sliders.each((i, slider) => {
      const $slider = $(slider);

      const config = {
        rows: 0,
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 992,
            settings: 'unslick',
          },
        ],
      };

      $slider.slick(config);
    });
  },
};

export default homeSlider;
